import Polyline from './Polyline';
import Polylines from './Polylines';
import PolylineSource from './PolylineSource';
import SurfaceTypePolyline from './SurfaceTypePolyline';

export default Polyline;
export { Polylines };
export { PolylineSource };
export { SurfaceTypePolyline };

// Export images directly from the only component with images being used
export { chevronImages as polylineImages } from '../../utils/images';
